'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushObject = void 0;
var $ = require("jquery");
var func_1 = require("./func");
var PushObject = /** @class */ (function () {
    function PushObject() {
        this.windowHeight = 0;
        this.windowWidth = 0;
        // ポップアップ用オブジェクト
        this.popupTops = {};
        // カニ
        this.kani = { action: false, num: 0, top: 0, zero: 0, height: 0, left: 0, move: 0 };
        // イルカ
        this.dolphin = { action: false, num: 0, top: 0, zero: 0, height: 0, left: 0, move: 0 };
        // くじら
        this.wheel = { action: false, num: 0, top: 0, zero: 0, height: 0, left: 0, move: 0 };
        // お船
        this.ship = { action: false, num: 0, top: 0, zero: 0, height: 0, left: 0, move: 0 };
        this.isPC = false;
        this.isTab = false;
        this.isSP = false;
        var self = this;
        $(document).ready(function () {
            self.windowHeight = $(window).height();
            self.windowWidth = $(window).width();
            // kani
            var kani = $('.trigObj[data-type="kani"]').eq(0);
            self.setKani(kani);
            self.setKaniInitialPosition();
            // dolphin
            var dolphin = $('.trigObj[data-type="dolphin"]').eq(0);
            self.setDolphin(dolphin);
            self.setDolphinInitialPosition();
            // wheel
            var wheel = $('.trigObj[data-type="wheel"]').eq(0);
            self.setWheel(wheel);
            self.setWheelInitialPosition();
            // ship
            var ship = $('.trigObj[data-type="ship"]').eq(0);
            self.setShip(ship);
            self.setShipInitialPosition();
            // popup
            var popups = $('.trigObj[data-type="popup"]');
            var obj, top, objNum;
            for (var i = 0; i < popups.length; i++) {
                obj = popups.eq(i);
                objNum = obj.data('obj');
                top = Math.floor(obj.offset().top);
                if (top) {
                    self.popupTops[objNum] = top;
                }
            }
            self.isPC = func_1.default.isPC();
            self.isTab = func_1.default.isTab();
            self.isSP = func_1.default.isSP();
        });
        var scrollTop = 0;
        // スクロール中
        var isScrolling = false;
        var timeoutKani, timeoutDolphin;
        $(window).scroll(function () {
            isScrolling = true;
            $('.trigObj[data-obj="' + self.kani.num + '"]').attr('data-rumble', 'kani');
            clearTimeout(timeoutKani);
            $('.trigObj[data-obj="' + self.dolphin.num + '"]').attr('data-rumble', 'dolphin');
            clearTimeout(timeoutDolphin);
            scrollTop = $(this).scrollTop();
            // popup
            Object.keys(self.popupTops).forEach(function (objNum) {
                var top = self.popupTops[objNum];
                if (scrollTop > top - self.windowHeight + 80) {
                    $('.trigObj[data-obj="' + objNum + '"]')
                        .css({
                        transform: 'rotateX(0deg) scale(1)'
                    });
                }
            });
            // Kani
            if (self.inObjectArea(scrollTop, self.kani)) {
                self.kani.move = (scrollTop + self.windowHeight - self.kani.top);
                self.kani.left = self.kani.zero - self.kani.move;
                $('.trigObjBox[data-obj="' + self.kani.num + '"]').css({ marginLeft: self.kani.left });
            }
            timeoutKani = setTimeout(function () {
                isScrolling = false;
                $('.trigObj[data-obj="' + self.kani.num + '"]').attr('data-rumble', 0);
            }, 200);
            // Dolphin
            if (self.inObjectArea(scrollTop, self.dolphin)) {
                if (self.isPC) {
                    self.dolphin.move = (scrollTop + self.windowHeight - self.dolphin.top) * 0.2;
                    self.dolphin.left = self.dolphin.zero - self.dolphin.move;
                    $('.trigObjBox[data-obj="' + self.dolphin.num + '"]').css({ marginLeft: self.dolphin.left });
                }
                else {
                    self.dolphin.move = (scrollTop + self.windowHeight - self.dolphin.top) * 0.4;
                    self.dolphin.left = self.dolphin.move - self.dolphin.zero;
                    $('.trigObjBox[data-obj="' + self.dolphin.num + '"]').css({ marginRight: self.dolphin.left });
                }
            }
            timeoutDolphin = setTimeout(function () {
                isScrolling = false;
                $('.trigObj[data-obj="' + self.dolphin.num + '"]').attr('data-rumble', 0);
            }, 500);
            // Wheel
            if (self.inObjectArea(scrollTop, self.wheel)) {
                if (self.isPC) {
                    self.wheel.move = (scrollTop + self.windowHeight - self.wheel.top) * 0.2;
                }
                else {
                    self.wheel.move = (scrollTop + self.windowHeight - self.wheel.top) * 0.4;
                }
                self.wheel.left = self.wheel.zero + self.wheel.move;
                $('.trigObjBox[data-obj="' + self.wheel.num + '"]').css({ marginLeft: self.wheel.left });
            }
            // Ship
            if (self.inObjectArea(scrollTop, self.ship)) {
                if (self.isPC) {
                    self.ship.move = (scrollTop + self.windowHeight - self.ship.top) * 1.5;
                    self.ship.left = self.ship.zero - self.ship.move;
                    $('.trigObjBox[data-obj="' + self.ship.num + '"]').css({ marginLeft: self.ship.left });
                }
                else {
                    self.ship.move = (scrollTop + self.windowHeight - self.ship.top) * 1.5;
                    self.ship.left = self.ship.move - self.ship.zero;
                    $('.trigObjBox[data-obj="' + self.ship.num + '"]').css({ marginRight: self.ship.left });
                }
            }
        });
    }
    PushObject.prototype.inObjectArea = function (scrollTop, obj) {
        return scrollTop >= obj.top - this.windowHeight && scrollTop <= obj.top + obj.height;
    };
    PushObject.prototype.setKani = function (kani) {
        this.kani.num = kani.data('obj');
        this.kani.zero = 500;
        this.kani.height = kani.height();
        this.kani.top = Math.floor(kani.offset().top);
    };
    PushObject.prototype.setKaniInitialPosition = function () {
        $('.trigObjBox[data-obj="' + this.kani.num + '"]').css({ marginLeft: this.kani.zero });
    };
    PushObject.prototype.setDolphin = function (dolphin) {
        this.dolphin.num = dolphin.data('obj');
        if (this.isPC) {
            this.wheel.zero = 500;
        }
        else {
            this.wheel.zero = 10;
        }
        this.dolphin.height = dolphin.height();
        this.dolphin.top = Math.floor(dolphin.offset().top);
    };
    PushObject.prototype.setDolphinInitialPosition = function () {
        if (this.isPC) {
            $('.trigObjBox[data-obj="' + this.dolphin.num + '"]').css({ marginLeft: this.dolphin.zero });
        }
        else {
            $('.trigObjBox[data-obj="' + this.dolphin.num + '"]').css({ marginRight: this.dolphin.zero });
        }
    };
    PushObject.prototype.setWheel = function (wheel) {
        this.wheel.num = wheel.data('obj');
        if (this.isPC) {
            this.wheel.zero = -200;
        }
        else {
            this.wheel.zero = 10;
        }
        this.wheel.height = wheel.height();
        this.wheel.top = Math.floor(wheel.offset().top);
    };
    PushObject.prototype.setWheelInitialPosition = function () {
        if (this.isPC) {
            $('.trigObjBox[data-obj="' + this.wheel.num + '"]').css({ marginLeft: this.wheel.zero });
        }
        else {
            $('.trigObjBox[data-obj="' + this.wheel.num + '"]').css({ marginRight: this.wheel.zero });
        }
    };
    PushObject.prototype.setShip = function (ship) {
        this.ship.num = ship.data('obj');
        this.ship.zero = 500;
        this.ship.height = ship.height();
        this.ship.top = Math.floor(ship.offset().top);
    };
    PushObject.prototype.setShipInitialPosition = function () {
        if (this.isPC) {
            $('.trigObjBox[data-obj="' + this.ship.num + '"]').css({ marginLeft: this.ship.zero });
        }
        else {
            $('.trigObjBox[data-obj="' + this.ship.num + '"]').css({ marginRight: this.ship.zero });
        }
    };
    return PushObject;
}());
exports.PushObject = PushObject;
exports.default = PushObject;
